import {Directive, ElementRef, Input, OnInit} from '@angular/core';
import {AuthService} from "../../modules/auth";

@Directive({
  selector: '[isGranted]',
  standalone: true,
})
export class IsGrantedDirective implements OnInit {

  @Input('isGranted') grantedRoles?: string | string[] = undefined;
  @Input() ifNotGranted?: 'remove'|'hide' = 'remove';

  constructor(private authService: AuthService, private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    if (!this.grantAccess()) {
      'hide' === this.ifNotGranted ? this.elementRef.nativeElement.style.display = 'none' : this.elementRef.nativeElement.remove()
    }
  }

  grantAccess() {
    return undefined !== this.grantedRoles && this.authService.isAuthorized( this.grantedRoles);
  }

}
